import { useContentPartImage } from "@assistant-ui/react";

export const ImageContent = () => {
  const contentPart = useContentPartImage();

  // Try to get the image URL from different possible properties
  const imageUrl = contentPart?.image || contentPart?.src || contentPart?.url;

  if (!imageUrl) {
    console.log('No image URL found, rendering fallback');
    return (
      <div className="my-4 p-4 bg-gray-100 rounded-lg">
        <p className="text-sm text-gray-600">📊 Visualization available</p>
        <p className="text-xs text-gray-500 mt-1">Unable to display image directly. Please check console for details.</p>
        <pre className="text-xs mt-2 bg-gray-200 p-2 rounded">{JSON.stringify(contentPart, null, 2)}</pre>
      </div>
    );
  }

  // Check if this is an HTML file (interactive Plotly) or image
  // Parse URL to handle query parameters in presigned URLs
  const isHtmlVisualization = imageUrl && (() => {
    try {
      const url = new URL(imageUrl);
      return url.pathname.endsWith('.html');
    } catch {
      return imageUrl.includes('.html');
    }
  })();

  return (
    <div className="my-4 border-2 border-blue-500 p-2">
      <p className="text-sm text-gray-600 mb-2">📊 Visualization {isHtmlVisualization && '(Interactive)'}</p>

      {isHtmlVisualization ? (
        // Render HTML visualizations (Plotly) in iframe
        <iframe
          src={imageUrl}
          title="Interactive Visualization"
          className="w-full rounded-lg shadow-md border border-gray-200"
          style={{
            height: '400px',
            maxWidth: '100%'
          }}
          sandbox="allow-scripts allow-same-origin"
          onError={(e) => {
            console.error('Error loading HTML visualization:', e);
          }}
        />
      ) : (
        // Render static images (matplotlib/seaborn)
        <img
          src={imageUrl}
          alt="Visualization"
          className="max-w-full h-auto rounded-lg shadow-md cursor-pointer hover:shadow-lg transition-shadow"
          style={{
            maxHeight: '300px',
            maxWidth: '500px',
            objectFit: 'contain'
          }}
          onClick={() => window.open(imageUrl, '_blank')}
          title="Click to view full size"
          onLoad={() => {}}
          onError={() => {}}
        />
      )}
    </div>
  );
};